import CryptoJS from 'crypto-js'; //https://www.npmjs.com/package/crypto-js
import $ from 'jquery';

/*****************/
//Reconstructed from https://github.com/adlnet/xAPIWrapper
/*****************/


const debug = true;
const xapiVersion = "1.0.1";


if ( !Date.prototype.toISOString ) {
    ( function() {

        function pad(number) {
            let r = String(number);
            if ( r.length === 1 ) {
                r = '0' + r;
            }
            return r;
        }

        Date.prototype.toISOString = function() {
            return this.getUTCFullYear()
                + '-' + pad( this.getUTCMonth() + 1 )
                + '-' + pad( this.getUTCDate() )
                + 'T' + pad( this.getUTCHours() )
                + ':' + pad( this.getUTCMinutes() )
                + ':' + pad( this.getUTCSeconds() )
                + '.' + String( (this.getUTCMilliseconds()/1000).toFixed(3) ).slice( 2, 5 )
                + 'Z';
        };

    }() );
}

// shim for old-style Base64 lib
function toBase64(text){
    if(CryptoJS && CryptoJS.enc.Base64)
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Latin1.parse(text));
    else
        return CryptoJS.enc.Base64.encode(text);
}

// shim for old-style crypto lib
function toSHA1(text){
    if(CryptoJS && CryptoJS.SHA1)
        return CryptoJS.SHA1(text).toString();
    else
        return Crypto.util.bytesToHex( Crypto.SHA1(text,{asBytes:true}) );
}
function toSHA256(text){
    if(CryptoJS && CryptoJS.SHA256)
        return CryptoJS.SHA256(text).toString();
}

// check if string or object is date, if it is, return date object
// feburary 31st == march 3rd in this solution
function isDate(date) {
    // check if object is being passed
    let d;
    if ( Object.prototype.toString.call(date) === "[object Date]" )
        d = date;
    else
        d = new Date(date);
    // deep check on date object
    if ( Object.prototype.toString.call(d) === "[object Date]" )
    {
        // it is a date
        if ( isNaN( d.valueOf() ) )
        {
            this.log("Invalid date String passed");
            return null;
        } else {
            return d;
        }
    } else {
        // not a date
        this.log("Invalid date object");
        return null;
    }
}

class xAPI {

    static _getobj(obj, path){
        let parts = path.split('.');

        let part = parts[0];
        path = parts.slice(1).join('.');

        if( !obj[part] ){
            if( /\[\]$/.test(part) ){
                part = part.slice(0,-2);
                obj[part] = [];
            }
            else
                obj[part] = {};
        }

        if( !path )
            return obj[part];
        else
            return this._getobj(obj[part], path);
    }

    static getByteLen(normal_val) {
        // Force string type
        normal_val = String(normal_val);

        let byteLen = 0;
        for (let i = 0; i < normal_val.length; i++) {
            let c = normal_val.charCodeAt(i);
            byteLen += c < (1 <<  7) ? 1 :
                c < (1 << 11) ? 2 :
                    c < (1 << 16) ? 3 :
                        c < (1 << 21) ? 4 :
                            c < (1 << 26) ? 5 :
                                c < (1 << 31) ? 6 : Number.NaN;
        }
        return byteLen;
    }

    static Config()
    {
        let conf = {};
        conf['endpoint'] = "http://localhost:8000/xapi/";
        try
        {
            conf['auth'] = "Basic " + toBase64('tom:1234');
        }
        catch (e)
        {
            //log("Exception in Config trying to encode auth: " + e);
        }

        return conf;
    }

    static Statement(actor,verb,object)
    {

        // initialize
        this.generateId = generateId.bind(this);

        // if first arg is an xapi statement, parse
        if( actor && actor.actor && actor.verb && actor.object ){



            let stmt = actor;
            for(let i in stmt){
                if(i != 'actor' && i != 'verb' && i != 'object')
                    this[i] = stmt[i];
            }
            actor = stmt.actor;
            verb = stmt.verb;
            object = stmt.object;
        }

        if(actor){
            if( actor instanceof xAPI.Agent )
                this.actor = actor;
            else if(actor.objectType === 'Agent' || !actor.objectType){
                this.actor = xAPI.Agent(actor);
            }else if(actor.objectType === 'Group')
                this.actor = xAPI.Group(actor);

        }
        else this.actor = null;

        if(verb){
            if( typeof verb.id !== 'undefined' )
                this.verb = verb;
            else
                this.verb = xAPI.Verb(verb);
        }
        else this.verb = null;

        // decide what kind of object was passed
        if(object)
        {
            if( object.objectType === 'Activity' || !object.objectType ){
                if( typeof object.id !== 'undefined' )
                    this.object = object;
                else
                    this.object = xAPI.Activity(object);
            }
            else if( object.objectType === 'Agent' ){
                if( object instanceof xAPI.Agent )
                    this.object = object;
                else
                    this.object = new xAPI.Agent(object);
            }
            else if( object.objectType === 'Group' ){
                if( object instanceof xAPI.Group )
                    this.object = object;
                else
                    this.object = xAPI.Group(object);
            }
            else if( object.objectType === 'StatementRef' ){
                if( typeof object.id !== 'undefined' )
                    this.object = object;
                else
                    this.object = xAPI.StatementRef(object);
            }
            else if( object.objectType === 'SubStatement' ){
                if( object instanceof xAPI.SubStatement )
                    this.object = object;
                else
                    this.object = xAPI.SubStatement(object);
            }
            else this.object = null;
        }
        else this.object = null;


        function generateId(){
            this.id = xAPI.ruuid();
        }
    }

    static Agent(identifier, name){
        let agent = {};

        agent.objectType = 'Agent';
        agent.name = name;

        // figure out what type of identifier was given
        if( identifier && (identifier.mbox || identifier.mbox_sha1sum || identifier.openid || identifier.account) ){
            for(let i in identifier){
                agent[i] = identifier[i];

            }
        }
        else if( /^mailto:/.test(identifier) ){
            agent.mbox = identifier;
        }
        else if( /^[0-9a-f]{40}$/i.test(identifier) ){
            agent.mbox_sha1sum = identifier;
        }
        else if( /^http[s]?:/.test(identifier) ){
            agent.openid = identifier;
        }
        else if( identifier && identifier.homePage && identifier.name ){
            agent.account = identifier;
        }
        return agent;
    }

    static Group(identifier, members, name)
    {
        let group = {};
        xAPI.Agent.call(this, identifier, name);
        group.member = members;
        group.objectType = 'Group';
        return group;
    }

    static Verb(id, description)
    {
        let verb = {};
        // if passed a verb object then copy and return
        if( id && id.id ){
            for(let i in id){
                verb[i] = id[i];
            }
            return;
        }

        // save id and build language map
        verb.id = id;
        if(description)
        {
            if( typeof(description) === 'string' || description instanceof String ){
                verb.display = {'en-US': description};
            }
            else {
                verb.display = description;
            }
        }

        return verb;
    }

    static Activity(id, name, description, type)
    {
        let activity = {};
        // if first arg is activity, copy everything over
        if(id && id.id){
            let act = id;
            for(let i in act){
                activity[i] = act[i];
            }
            return;
        }

        activity.objectType = 'Activity';
        activity.id = id;
        if( name || description || type)
        {
            activity.definition = {};

            if( typeof(name) === 'string' || name instanceof String )
                activity.definition.name = {'en-US': name};
            else if(name)
                activity.definition.name = name;

            if( typeof(description) === 'string' || description instanceof String )
                activity.definition.description = {'en-US': description};
            else if(description)
                activity.definition.description = description;

            if(typeof type !== 'undefined'){
                activity.definition.type = type;
            }
        }
        return activity;
    }

    static StatementRef(id){
        let statementRef = {};

        if(id && id.id){
            for(let i in id){
                statementRef[i] = id[i];
            }
        }
        else {
            statementRef.objectType = 'StatementRef';
            statementRef.id = id;
        }
        return statementRef;
    }

    static SubStatement(actor, verb, object){
        let subStatement = {};
        subStatement = xAPI.XAPIStatement.call(this,actor,verb,object);
        subStatement.objectType = 'SubStatement';

        delete subStatement.id;
        delete subStatement.stored;
        delete subStatement.version;
        delete subStatement.authority;

        return subStatement;
    }

    static Verbs(){
        let verbs = {
            "abandoned" : {
                "id" : "https://w3id.org/xapi/adl/verbs/abandoned",
                "display" : {"en-US" : "abandoned"}
            },
            "answered" : {
                "id" : "http://adlnet.gov/expapi/verbs/answered",
                "display" : {"de-DE" : "beantwortete",
                    "en-US" : "answered",
                    "fr-FR" : "a répondu",
                    "es-ES" : "contestó"}
            },
            "asked" : {
                "id" : "http://adlnet.gov/expapi/verbs/asked",
                "display" : {"de-DE" : "fragte",
                    "en-US" : "asked",
                    "fr-FR" : "a demandé",
                    "es-ES" : "preguntó"}
            },
            "attempted" : {
                "id" : "http://adlnet.gov/expapi/verbs/attempted",
                "display" : {"de-DE" : "versuchte",
                    "en-US" : "attempted",
                    "fr-FR" : "a essayé",
                    "es-ES" : "intentó"}
            },
            "attended" : {
                "id" : "http://adlnet.gov/expapi/verbs/attended",
                "display" : {"de-DE" : "nahm teil an",
                    "en-US" : "attended",
                    "fr-FR" : "a suivi",
                    "es-ES" : "asistió"}
            },
            "commented" : {
                "id" : "http://adlnet.gov/expapi/verbs/commented",
                "display" : {"de-DE" : "kommentierte",
                    "en-US" : "commented",
                    "fr-FR" : "a commenté",
                    "es-ES" : "comentó"}
            },
            "completed" : {
                "id" : "http://adlnet.gov/expapi/verbs/completed",
                "display" : {"de-DE" : "beendete",
                    "en-US" : "completed",
                    "fr-FR" : "a terminé",
                    "es-ES" : "completó"}
            },
            "exited" : {
                "id" : "http://adlnet.gov/expapi/verbs/exited",
                "display" : {"de-DE" : "verließ",
                    "en-US" : "exited",
                    "fr-FR" : "a quitté",
                    "es-ES" : "salió"}
            },
            "experienced" : {
                "id" : "http://adlnet.gov/expapi/verbs/experienced",
                "display" : {"de-DE" : "erlebte",
                    "en-US" : "experienced",
                    "fr-FR" : "a éprouvé",
                    "es-ES" : "experimentó"}
            },
            "failed" : {
                "id" : "http://adlnet.gov/expapi/verbs/failed",
                "display" : {"de-DE" : "verfehlte",
                    "en-US" : "failed",
                    "fr-FR" : "a échoué",
                    "es-ES" : "fracasó"}
            },
            "imported" : {
                "id" : "http://adlnet.gov/expapi/verbs/imported",
                "display" : {"de-DE" : "importierte",
                    "en-US" : "imported",
                    "fr-FR" : "a importé",
                    "es-ES" : "importó"}
            },
            "initialized" : {
                "id" : "http://adlnet.gov/expapi/verbs/initialized",
                "display" : {"de-DE" : "initialisierte",
                    "en-US" : "initialized",
                    "fr-FR" : "a initialisé",
                    "es-ES" : "inicializó"}
            },
            "interacted" : {
                "id" : "http://adlnet.gov/expapi/verbs/interacted",
                "display" : {"de-DE" : "interagierte",
                    "en-US" : "interacted",
                    "fr-FR" : "a interagi",
                    "es-ES" : "interactuó"}
            },
            "launched" : {
                "id" : "http://adlnet.gov/expapi/verbs/launched",
                "display" : {"de-DE" : "startete",
                    "en-US" : "launched",
                    "fr-FR" : "a lancé",
                    "es-ES" : "lanzó"}
            },
            "mastered" : {
                "id" : "http://adlnet.gov/expapi/verbs/mastered",
                "display" : {"de-DE" : "meisterte",
                    "en-US" : "mastered",
                    "fr-FR" : "a maîtrisé",
                    "es-ES" : "dominó"}
            },
            "passed" : {
                "id" : "http://adlnet.gov/expapi/verbs/passed",
                "display" : {"de-DE" : "bestand",
                    "en-US" : "passed",
                    "fr-FR" : "a réussi",
                    "es-ES" : "aprobó"}
            },
            "preferred" : {
                "id" : "http://adlnet.gov/expapi/verbs/preferred",
                "display" : {"de-DE" : "bevorzugte",
                    "en-US" : "preferred",
                    "fr-FR" : "a préféré",
                    "es-ES" : "prefirió"}
            },
            "progressed" : {
                "id" : "http://adlnet.gov/expapi/verbs/progressed",
                "display" : {"de-DE" : "machte Fortschritt mit",
                    "en-US" : "progressed",
                    "fr-FR" : "a progressé",
                    "es-ES" : "progresó"}
            },
            "registered" : {
                "id" : "http://adlnet.gov/expapi/verbs/registered",
                "display" : {"de-DE" : "registrierte",
                    "en-US" : "registered",
                    "fr-FR" : "a enregistré",
                    "es-ES" : "registró"}
            },
            "responded" : {
                "id" : "http://adlnet.gov/expapi/verbs/responded",
                "display" : {"de-DE" : "reagierte",
                    "en-US" : "responded",
                    "fr-FR" : "a répondu",
                    "es-ES" : "respondió"}
            },
            "resumed" : {
                "id" : "http://adlnet.gov/expapi/verbs/resumed",
                "display" : {"de-DE" : "setzte fort",
                    "en-US" : "resumed",
                    "fr-FR" : "a repris",
                    "es-ES" : "continuó"}
            },
            "satisfied" : {
                "id" : "https://w3id.org/xapi/adl/verbs/satisfied",
                "display" : {"en-US" : "satisfied"}
            },
            "scored" : {
                "id" : "http://adlnet.gov/expapi/verbs/scored",
                "display" : {"de-DE" : "erreichte",
                    "en-US" : "scored",
                    "fr-FR" : "a marqué",
                    "es-ES" : "anotó"}
            },
            "shared" : {
                "id" : "http://adlnet.gov/expapi/verbs/shared",
                "display" : {"de-DE" : "teilte",
                    "en-US" : "shared",
                    "fr-FR" : "a partagé",
                    "es-ES" : "compartió"}
            },
            "suspended" : {
                "id" : "http://adlnet.gov/expapi/verbs/suspended",
                "display" : {"de-DE" : "pausierte",
                    "en-US" : "suspended",
                    "fr-FR" : "a suspendu",
                    "es-ES" : "aplazó"}
            },
            "terminated" : {
                "id" : "http://adlnet.gov/expapi/verbs/terminated",
                "display" : {"de-DE" : "beendete",
                    "en-US" : "terminated",
                    "fr-FR" : "a terminé",
                    "es-ES" : "terminó"}
            },
            "voided" : {
                "id" : "http://adlnet.gov/expapi/verbs/voided",
                "display" : {"de-DE" : "entwertete",
                    "en-US" : "voided",
                    "fr-FR" : "a annulé",
                    "es-ES" : "anuló"}
            },
            "waived" : {
                "id" : "https://w3id.org/xapi/adl/verbs/waived",
                "display" : {"en-US" : "waived"}
            },
            "earned" : {
                "id" : "http://id.tincanapi.com/verb/earned",
                "display" : {"en-US" : "earned"}
            }
        };

        return verbs;
    }

    static Lrs(config, verifyxapiversion){

        //public
        this.Statement = xAPI.Statement.bind(this);
        this.Agent = xAPI.Agent.bind(this);
        this.Group = xAPI.Group.bind(this);
        this.Verb = xAPI.Verb.bind(this);
        this.Activity = xAPI.Activity.bind(this);
        this.StatementRef = xAPI.StatementRef.bind(this);
        this.SubStatement = xAPI.SubStatement.bind(this);
        this.Verbs = xAPI.Verbs();

        this.updateSettings = xAPI.updateSettings.bind(this);
        this.getCurrentUrl = xAPI.getCurrentUrl.bind(this);
        this.updateAuth = xAPI.updateAuth.bind(this);
        this.searchParams = xAPI.searchParams.bind(this);
        this.hash = xAPI.hash.bind(this);
        this.changeConfig = xAPI.changeConfig.bind(this);

        this.generateRegistration = xAPI.generateRegistration.bind(this);
        this.addParentActivity = xAPI.addParentActivity.bind(this);
        this.addGroupingActivity = xAPI.addGroupingActivity.bind(this);
        this.addCategoryActivity = xAPI.addCategoryActivity.bind(this);
        this.addOtherContextActivity = xAPI.addOtherContextActivity.bind(this);

        this.prepareStatement = xAPI.prepareStatement.bind(this);
        this.sendStatement = xAPI.sendStatement.bind(this);
        this.buildMultipartPost = xAPI.buildMultipartPost.bind(this);
        this.sendStatements = xAPI.sendStatements.bind(this);
        this.getStatements = xAPI.getStatements.bind(this);
        this.getActivities = xAPI.getActivities.bind(this);
        this.sendState = xAPI.sendState.bind(this);
        this.getState = xAPI.getState.bind(this);
        this.deleteState = xAPI.deleteState.bind(this);
        this.sendActivityProfile = xAPI.sendActivityProfile.bind(this);
        this.getActivityProfile = xAPI.getActivityProfile.bind(this);
        this.deleteActivityProfile = xAPI.deleteActivityProfile.bind(this);
        this.testConfig = xAPI.testConfig.bind(this);
        this.log = xAPI.log.bind(this);


        this.lrs = xAPI.getLRSObject(config || {});
        if(typeof this.lrs === 'undefined'){
            this.lrs = {};
        }
        this.settings ={};

        if (this.lrs.user && this.lrs.password) this.updateAuth(this.lrs, this.lrs.user, this.lrs.password);
        if(typeof this.lrs.endpoint !== "undefined") {
            this.base = xAPI.getbase(this.lrs.endpoint);
        }
        this.withCredentials = false;
        this.withCredentials = config && config.withCredentials;



        if (verifyxapiversion && this.testConfig.call(this))
        {
            window.xAPI.XHR_request(this.lrs, this.lrs.endpoint+"about", "GET", null, null,
            function(r){
                if(r.status == 200)
                {
                    try
                    {
                        let lrsabout = JSON.parse(r.response);
                        let versionOK = false;
                        for (let idx in lrsabout.version)
                        {
                            if(lrsabout.version[idx] == xapiVersion)
                            {
                                versionOK = true;
                                break;
                            }
                        }
                        if (!versionOK)
                        {
                            this.log("The lrs version [" + lrsabout.version +"]"+
                                " does not match this wrapper's XAPI version [" + xapiVersion + "]");
                        }
                    }
                    catch(e)
                    {
                        this.log("The response was not an about object");
                    }
                }
                else
                {
                    this.log("The request to get information about the LRS failed: " + r);
                }
            }, null, false, null, this.withCredentials, false);
        }
    }

    static updateSettings(settings){
        this.settings = Object.assign({}, settings);
    }

    static getCurrentUrl(){
        let pathArray = window.location.href.split( '/' );
        let protocol = pathArray[0];
        let host = pathArray[2];
        let url = protocol + '//' + host;
        return url;
    }

    static getbase(url)
    {
        let l = document.createElement("a");
        l.href = url;
        if (l.protocol && l.host)
            return l.protocol + "//" + l.host;
        else
            this.log("Couldn't create base url from endpoint: " + this.lrs.endpoint);
    }

    static updateAuth(obj, username, password){
        obj.auth = "Basic " + toBase64(username + ":" + password);
    }

    static searchParams(){
        let sp = {"format" : "exact"};
        return sp;
    }

    static hash(tohash){
        if (!tohash) return null;
        try
        {
            return toSHA1(tohash);
        }
        catch(e)
        {
            this.log("Error trying to hash -- " + e);
            return null;
        }
    }

    static changeConfig(config){
        try
        {
            this.log("updating lrs object with new configuration");
            this.lrs = xAPI.mergeRecursive(this.lrs, config);
            if (config.user && config.password)
                this.updateAuth(this.lrs, config.user, config.password);
            this.base = xAPI.getbase(this.lrs.endpoint);
            this.withCredentials = config.withCredentials;

        }
        catch(e)
        {
            this.log("error while changing configuration -- " + e);
        }
    }

    static generateRegistration(stmt){
        xAPI._getobj(stmt,'context').registration = xAPI.ruuid();
        return stmt;
    }

    static addParentActivity(stmt,activity){
        xAPI._getobj(stmt,'context.contextActivities.parent[]').push(activity);
        return stmt;
    }

    static addGroupingActivity(stmt,activity){
        xAPI._getobj(stmt,'context.contextActivities.grouping[]').push(activity);
        return stmt;
    }

    static addCategoryActivity(stmt,activity){
        xAPI._getobj(stmt,'context.contextActivities.category[]').push(activity);
        return stmt;
    }


    static addOtherContextActivity(stmt,activity){
        xAPI._getobj(stmt,'context.contextActivities.other[]').push(activity);
        return stmt;
    }

    static prepareStatement(stmt)
    {
        if(stmt.actor === undefined){
            stmt.actor = JSON.parse(this.lrs.actor);
        }
        else if(typeof stmt.actor === "string") {
            stmt.actor = JSON.parse(stmt.actor);
        }
        if (this.lrs.grouping ||
            this.lrs.registration ||
            this.lrs.activity_platform) {
            if (!stmt.context) {
                stmt.context = {};
            }
        }

        if (this.lrs.grouping) {
            if (!stmt.context.contextActivities) {
                stmt.context.contextActivities = {};
            }
            stmt.context.contextActivities.grouping = [{ id : this.lrs.grouping }];
        }
        if (this.lrs.registration) {
            stmt.context.registration = this.lrs.registration;
        }
        if (this.lrs.activity_platform) {
            stmt.context.platform = this.lrs.activity_platform;
        }
    }

    static sendStatement(stmt, callback, attachments)
    {
        if (this.testConfig())
        {
            this.prepareStatement(stmt);
            let id;
            if (stmt['id'])
            {
                id = stmt['id'];
            }
            else
            {
                id = xAPI.ruuid();
                stmt['id'] = id;
            }

            let payload = JSON.stringify(stmt);
            let extraHeaders = null;
            if(attachments && attachments.length > 0)
            {
                extraHeaders = {};
                payload = this.buildMultipartPost(stmt,attachments,extraHeaders);
            }

            let params ={
                url: this.lrs.endpoint+"statements",
                method: "POST",
                data: payload,
                auth: this.lrs.auth,
                extraHeaders: extraHeaders,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });
        }
    }

    static buildMultipartPost(statement,attachments,extraHeaders)
    {
        statement.attachments = [];
        for(let i =0; i < attachments.length; i++)
        {
            //replace the term 'signature' with the hard coded definition for a signature attachment
            if(attachments[i].type == "signature")
            {
                attachments[i].type = {
                    "usageType": "http://xAPInet.gov/expapi/attachments/signature",
                    "display": {
                        "en-US": "A JWT signature"
                    },
                    "description": {
                        "en-US": "A signature proving the statement was not modified"
                    },
                    "contentType": "application/octet-stream"
                };
            }

            //compute the length and the sha2 of the attachment
            attachments[i].type.length = attachments[i].value.length;
            attachments[i].type.sha2 = toSHA256(attachments[i].value);

            //attach the attachment metadata to the statement
            statement.attachments.push(attachments[i].type);
        }

        let body = "";
        let CRLF = "\r\n";
        let boundary = (Math.random()+' ').substring(2,10)+(Math.random()+' ').substring(2,10);

        extraHeaders["Content-Type"] = "multipart/mixed; boundary=" + boundary;

        body += CRLF + '--' + boundary + CRLF + 'Content-Type:application/json' + CRLF + "Content-Disposition: form-data; name=\"statement\"" + CRLF + CRLF;
        body += JSON.stringify(statement);

        for(let i in attachments)
        {

            body += CRLF + '--' + boundary + CRLF + 'X-Experience-API-Hash:' + attachments[i].type.sha2 + CRLF + "Content-Type:application/octet-stream" + CRLF + "Content-Transfer-Encoding: binary" + CRLF + CRLF;
            body += attachments[i].value;
        }
        body += CRLF + "--" + boundary + "--" + CRLF;

        return body;
    }

    static sendStatements(stmtArray, callback)
    {
        if (this.testConfig())
        {
            for(let i in stmtArray)
            {
                this.prepareStatement(stmtArray[i]);
            }

            let params ={
                url: this.lrs.endpoint+"statements",
                method: "POST",
                data: JSON.stringify(stmtArray),
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });
        }
    }

    static getStatements(searchparams, more, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "statements";
            if (more)
            {
                url = this.base + more;
            }
            else
            {
                let urlparams = new Array();

                for (let s in searchparams)
                {
                    if (s == "until" || s == "since") {
                        let d = new Date(searchparams[s]);
                        urlparams.push(s + "=" + encodeURIComponent(d.toISOString()));
                    } else if (s == "agent") {
                        urlparams.push(s + "=" + encodeURIComponent(JSON.stringify(searchparams[s])));
                    } else {
                        urlparams.push(s + "=" + encodeURIComponent(searchparams[s]));
                    }
                }
                if (urlparams.length > 0)
                    url = url + "?" + urlparams.join("&");
            }

            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });
        }
    }

    static getActivities(activityid, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities?activityId=<activityid>";
            url = url.replace('<activityid>', encodeURIComponent(activityid));

            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });
        }
    }

    static sendState(activityid, agent, stateid, registration, stateval, matchHash, noneMatchHash)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>&stateId=<stateid>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));
            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));
            url = url.replace('<stateid>',encodeURIComponent(stateid));

            if (registration)
            {
                url += "&registration=" + encodeURIComponent(registration);
            }

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let method = "PUT";
            if (stateval)
            {
                if (stateval instanceof Array)
                {
                    stateval = JSON.stringify(stateval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                }
                else if (stateval instanceof Object)
                {
                    stateval = JSON.stringify(stateval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                    method = "POST";
                }
                else
                {
                    headers = headers || {};
                    headers["Content-Type"] ="application/octet-stream";
                }
            }
            else
            {
                this.log("No activity state was included.");
                return false;
            }

            let params ={
                url: url,
                method: method,
                data: stateval,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static getState(activityid, agent, stateid, registration, since, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));
            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));

            if (stateid)
            {
                url += "&stateId=" + encodeURIComponent(stateid);
            }

            if (registration)
            {
                url += "&registration=" + encodeURIComponent(registration);
            }

            if(since)
            {
                since = isDate(since);
                if (since != null) {
                    url += '&since=' + encodeURIComponent(since.toISOString());
                }
            }

            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });
        }
    }

    static deleteState(activityid, agent, stateid, registration, matchHash, noneMatchHash, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>&stateId=<stateid>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));
            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));
            url = url.replace('<stateid>',encodeURIComponent(stateid));

            if (registration)
            {
                url += "&registration=" + encodeURIComponent(registration);
            }

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let params ={
                url: url,
                method: "DELETE",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static sendActivityProfile(activityid, profileid, profileval, matchHash, noneMatchHash, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>&profileId=<profileid>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));
            url = url.replace('<profileid>',encodeURIComponent(profileid));

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let method = "PUT";
            if (profileval)
            {
                if (profileval instanceof Array)
                {
                    profileval = JSON.stringify(profileval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                }
                else if (profileval instanceof Object)
                {
                    profileval = JSON.stringify(profileval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                    method = "POST";
                }
                else
                {
                    headers = headers || {};
                    headers["Content-Type"] ="application/octet-stream";
                }
            }
            else
            {
                this.log("No activity profile was included.");
                return false;
            }

            let params ={
                url: url,
                method: method,
                data: profileval,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static getActivityProfile(activityid, profileid, since, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));

            if (profileid)
            {
                url += "&profileId=" + encodeURIComponent(profileid);
            }

            if(since)
            {
                since = isDate(since);
                if (since != null) {
                    url += '&since=' + encodeURIComponent(since.toISOString());
                }
            }

            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static deleteActivityProfile(activityid, profileid, matchHash, noneMatchHash, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>&profileId=<profileid>";

            url = url.replace('<activity ID>',encodeURIComponent(activityid));
            url = url.replace('<profileid>',encodeURIComponent(profileid));

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let params ={
                url: url,
                method: "DELETE",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static getAgents(agent, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "agents?agent=<agent>";
            url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));


            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static sendAgentProfile(agent, profileid, profileval, matchHash, noneMatchHash, callback)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "agents/profile?agent=<agent>&profileId=<profileid>";

            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));
            url = url.replace('<profileid>',encodeURIComponent(profileid));

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let method = "PUT";
            if (profileval)
            {
                if (profileval instanceof Array)
                {
                    profileval = JSON.stringify(profileval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                }
                else if (profileval instanceof Object)
                {
                    profileval = JSON.stringify(profileval);
                    headers = headers || {};
                    headers["Content-Type"] ="application/json";
                    method = "POST";
                }
                else
                {
                    headers = headers || {};
                    headers["Content-Type"] ="application/octet-stream";
                }
            }
            else
            {
                this.log("No agent profile was included.");
                return false;
            }

            let params ={
                url: url,
                method: method,
                data: profileval,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static getAgentProfile(agent, profileid, since, callback)
    {
        if (this.testConfig()){
            let url = this.lrs.endpoint + "agents/profile?agent=<agent>";

            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));
            url = url.replace('<profileid>',encodeURIComponent(profileid));

            if (profileid)
            {
                url += "&profileId=" + encodeURIComponent(profileid);
            }

            if(since)
            {
                since = isDate(since);
                if (since != null) {
                    url += '&since=' + encodeURIComponent(since.toISOString());
                }
            }

            let params ={
                url: url,
                method: "GET",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: null,
                withCredentials: this.withCredentials,
            };

            return xAPI.request(params).then(response => {
                return response;
            }).catch(error => {
                throw(error);
            });

        }
    }

    static deleteAgentProfile(agent, profileid, matchHash, noneMatchHash)
    {
        if (this.testConfig())
        {
            let url = this.lrs.endpoint + "agents/profile?agent=<agent>&profileId=<profileid>";

            url = url.replace('<agent>',encodeURIComponent(JSON.stringify(agent)));
            url = url.replace('<profileid>',encodeURIComponent(profileid));

            let headers = null;
            if(matchHash && noneMatchHash)
            {
                this.log("Can't have both If-Match and If-None-Match");
            }
            else if (matchHash)
            {
                headers = {"If-Match":xAPI.formatHash(matchHash)};
            }
            else if (noneMatchHash)
            {
                headers = {"If-None-Match":xAPI.formatHash(noneMatchHash)};
            }

            let params ={
                url: url,
                method: "DELETE",
                data: null,
                auth: this.lrs.auth,
                extraHeaders: headers,
                withCredentials: this.withCredentials,
            };
        }
    }

    static testConfig()
    {
        try
        {
            return this.lrs.endpoint != undefined && this.lrs.endpoint != "";
        }
        catch(e)
        {
            return false;
        }
    }

    static log(message)
    {
        if (!debug) return false;
        try
        {
            console.log(message);
            return true;
        }
        catch(e){return false;}
    }

    static mergeRecursive(obj1, obj2)
    {
        for (let p in obj2)
        {
            let prop = obj2[p];
            this.log(p + " :: " + prop);
            try
            {
                // Property in destination object set; update its value.
                if ( obj2[p].constructor==Object )
                {
                    obj1[p] = this.mergeRecursive(obj1[p], obj2[p]);

                }
                else
                {
                    if (obj1 == undefined)
                    {
                        obj1 = new Object();
                    }
                    obj1[p] = obj2[p];
                }
            }
            catch(e)
            {
                if (obj1 == undefined)
                {
                    obj1 = new Object();
                }
                // Property in destination object not set; create it and set its value.
                obj1[p] = obj2[p];
            }
        }

        return obj1;
    }

    static getLRSObject(config)
    {
        let lrsProps = ["endpoint","auth","actor","registration","activity_id", "grouping", "activity_platform"];
        let lrs = new Object();
        let qsVars, prop;

        qsVars = this.parseQueryString();
        if (qsVars !== undefined && Object.keys(qsVars).length !== 0) {
            for (let i = 0; i<lrsProps.length; i++){
                prop = lrsProps[i];
                if (qsVars[prop]){
                    lrs[prop] = qsVars[prop];
                    delete qsVars[prop];
                }
            }
            if (Object.keys(qsVars).length !== 0) {
                lrs.extended = qsVars;
            }

            lrs = this.mergeRecursive(config, lrs);
        }
        else {
            lrs = config;
        }

        return lrs;
    }

    static parseQueryString()
    {
        let qs, pairs, pair, ii, parsed;

        qs = window.location.search.substr(1);

        pairs = qs.split('&');
        parsed = {};
        for ( ii = 0; ii < pairs.length; ii++) {
            pair = pairs[ii].split('=');
            if (pair.length === 2 && pair[0]) {
                parsed[pair[0]] = decodeURIComponent(pair[1]);
            }
        }

        return parsed;
    }


    static ruuid()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }



    static dateFromISOString(isostr)
    {
        let regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" + "([T| ]([0-9]{2}):([0-9]{2})(:([0-9]{2})(\\.([0-9]+))?)?" +  "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
        let d = isostr.match(new RegExp(regexp));

        let offset = 0;
        let date = new Date(d[1], 0, 1);

        if (d[3]) { date.setMonth(d[3] - 1); }
        if (d[5]) { date.setDate(d[5]); }
        if (d[7]) { date.setHours(d[7]); }
        if (d[8]) { date.setMinutes(d[8]); }
        if (d[10]) { date.setSeconds(d[10]); }
        if (d[12]) { date.setMilliseconds(Number("0." + d[12]) * 1000); }
        if (d[14]) {
            offset = (Number(d[16]) * 60) + Number(d[17]);
            offset *= ((d[15] == '-') ? 1 : -1);
        }

        offset -= date.getTimezoneOffset();
        let time = (Number(date) + (offset * 60 * 1000));

        let dateToReturn = new Date();
        dateToReturn.setTime(Number(time));
        return dateToReturn;
    }

    static request(params){
        return new Promise(function (resolve, reject) {

            //headers
            let headers = {
                "Content-Type": "application/json",
                "Authorization": params.auth,
                "X-Experience-API-Version": xapiVersion,
            };
            if(params.extraHeaders !== null){
                for(let headerName in params.extraHeaders){
                    headers[headerName] = params.extraHeaders[headerName];
                }
            }

            $.ajax({
                type: params.method,
                url: params.url,
                headers: headers,
                data: params.data,
                contentType:'application/json',
                dataType:'json',
                urlParts: params.url.toLowerCase().match(/^(.+):\/\/([^:\\/]*):?(\d+)?(\/.*)?$/),
                location: window.location,
                withCredentials: params.withCredentials

            }).done(resolve).fail(reject);

        });
    }

    static formatHash(hash)
    {
        return (hash==="*") ? hash : '"'+hash+'"';
    }


}

export default xAPI;


/** WEBPACK FOOTER **
 ** ./src/wrappers/xapi/xAPIWrap.js
 **/